import React from 'react';

import { MenuEntry } from '@europrocurement/flexy-components';

import { ADMIN_USERS } from '@europrocurement/l2d-keycloak';
import {
    antennesListePath,
    apiUtilisateursBasePath,
    utilisateursSubPath,
    utilisateursUtilisateursPath,
    groupesTravailSubPath,
    utilisateursGroupesTravailPath,
} from './constants/paths';

import UtilisateursList from './views/Utilisateurs/UtilisateursList';
import UtilisateurFiche from './views/Utilisateurs/UtilisateurFiche';
import { AntennesList } from './views/Antennes/AntennesList';
import { AntenneFiche } from './views/Antennes/AntenneFiche';
import GroupesTravailList from './views/GroupesTravail/GroupesTravailList';
import GroupeTravailFiche from './views/GroupesTravail/GroupeTravailFiche';
import { UtilisateursOutlet } from './UtilisateursOutlet';

export const UtilisateursRouter = {
    path: apiUtilisateursBasePath,
    element: <UtilisateursOutlet />,
    children: [
        {
            path: utilisateursSubPath,
            children: [
                {
                    path: '',
                    index: true,
                    element: <UtilisateursList />,
                },
                {
                    path: ':idUtilisateur',
                    element: <UtilisateurFiche />,
                },
            ],
        },
        {
            path: antennesListePath,
            children: [
                {
                    path: '',
                    index: true,
                    element: <AntennesList />,
                },
                {
                    path: ':idAntenne',
                    element: <AntenneFiche />,
                },
            ],
        },
        {
            path: groupesTravailSubPath,
            children: [
                {
                    path: '',
                    index: true,
                    element: <GroupesTravailList />,
                },
                {
                    path: ':idGroupeTravail',
                    element: <GroupeTravailFiche />,
                },
            ],
        },
    ],
};

// Administration Sub-menu entry.
export const UtilisateursMenuEntries: MenuEntry[] = [
    {
        title: 'Gestion des Utilisateurs',
        icon: 'users',
        role: ADMIN_USERS,
        children: [
            {
                title: 'Utilisateurs',
                icon: 'user',
                href: `${utilisateursUtilisateursPath}`,
            },
            {
                title: 'Antennes',
                icon: 'map-location',
                href: `${apiUtilisateursBasePath}/${antennesListePath}`,
            },
            {
                title: 'Groupes de Travail',
                icon: 'users',
                href: `${utilisateursGroupesTravailPath}`,
            },
        ],
    },
];
